const HANDOFF_QUERY = 'authHandoff'

const AUTH_KEYS = [
  'accessToken',
  'refreshToken',
  'userId',
  'username',
  'isAdmin',
  'isApproved',
  'isDistributor',
  'userRole',
  'userPermissions',
  'userPermissionsTimestamp',
]

const encodePayload = (data) => {
  const json = JSON.stringify(data)
  const bytes = new TextEncoder().encode(json)
  let binary = ''
  bytes.forEach((b) => { binary += String.fromCharCode(b) })
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

const decodePayload = (encoded) => {
  const base64 = encoded.replace(/-/g, '+').replace(/_/g, '/')
  const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4)
  const binary = atob(padded)
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0))
  return JSON.parse(new TextDecoder().decode(bytes))
}

export const serializeAuthSession = () => {
  const data = {}
  AUTH_KEYS.forEach((key) => {
    const value = localStorage.getItem(key)
    if (value != null) data[key] = value
  })
  if (!data.accessToken) return null
  return encodePayload(data)
}

export const appendAuthHandoffToUrl = (url) => {
  const payload = serializeAuthSession()
  if (!payload) return url

  const target = new URL(url, window.location.origin)
  target.searchParams.set(HANDOFF_QUERY, payload)
  return target.toString()
}

/** Restaura la sesión desde ?authHandoff=… y limpia la URL. */
export const applyAuthHandoff = () => {
  if (typeof window === 'undefined') return false

  const params = new URLSearchParams(window.location.search)
  const payload = params.get(HANDOFF_QUERY)
  if (!payload) return false

  try {
    const data = decodePayload(payload)
    AUTH_KEYS.forEach((key) => {
      const value = data[key]
      if (typeof value === 'string') {
        localStorage.setItem(key, value)
      }
    })

    params.delete(HANDOFF_QUERY)
    const search = params.toString()
    const cleanUrl = `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`
    window.history.replaceState({}, '', cleanUrl)
    return true
  } catch {
    params.delete(HANDOFF_QUERY)
    const search = params.toString()
    window.history.replaceState({}, '', `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`)
    return false
  }
}
